var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddMemberIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1508_45020)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 2.65515C9.28645 2.65515 4.65527 7.28632 4.65527 13C4.65527 18.7136 9.28645 23.3448 15.0001 23.3448C20.7138 23.3448 25.3449 18.7136 25.3449 13C25.3449 7.28632 20.7138 2.65515 15.0001 2.65515ZM20.3794 13.8276H15.8277V18.3793C15.8277 18.5988 15.7405 18.8093 15.5853 18.9645C15.4301 19.1197 15.2196 19.2069 15.0001 19.2069C14.7806 19.2069 14.5701 19.1197 14.4149 18.9645C14.2597 18.8093 14.1725 18.5988 14.1725 18.3793V13.8276H9.62079C9.4013 13.8276 9.1908 13.7404 9.0356 13.5852C8.8804 13.43 8.7932 13.2195 8.7932 13C8.7932 12.7805 8.8804 12.57 9.0356 12.4148C9.1908 12.2596 9.4013 12.1724 9.62079 12.1724H14.1725V7.62067C14.1725 7.40118 14.2597 7.19068 14.4149 7.03548C14.5701 6.88027 14.7806 6.79308 15.0001 6.79308C15.2196 6.79308 15.4301 6.88027 15.5853 7.03548C15.7405 7.19068 15.8277 7.40118 15.8277 7.62067V12.1724H20.3794C20.5989 12.1724 20.8094 12.2596 20.9646 12.4148C21.1198 12.57 21.207 12.7805 21.207 13C21.207 13.2195 21.1198 13.43 20.9646 13.5852C20.8094 13.7404 20.5989 13.8276 20.3794 13.8276Z",
    fill: "#539FA3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1508_45020",
    x: -1,
    y: -1,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.376471 0 0 0 0 0.380392 0 0 0 0 0.439216 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1508_45020"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.156863 0 0 0 0 0.160784 0 0 0 0 0.239216 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1508_45020",
    result: "effect2_dropShadow_1508_45020"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1508_45020",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddMemberIcon);
export default __webpack_public_path__ + "static/media/add_member_icon.10bd9bf9c48257366748a65b5ffdab16.svg";
export { ForwardRef as ReactComponent };